import Button from "./Button";

export default function ListPagination({
  currentPage = 2,
  lastPage = 10,
  onPageChanged,
}) {
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChanged(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      onPageChanged(currentPage + 1);
    }
  };

  const handlePageInputChange = (e) => {
    const newPage = Number(e.target.value);
    if (newPage >= 1 && newPage <= lastPage) {
      onPageChanged(newPage);
    }
  };

  return lastPage > 1 ? (
    <div className="display-flex flex-justify-center flex-gap-xs">
      {currentPage > 1 && (
        <Button
          text="<- Previous"
          type="empty"
          onClicked={handlePreviousPage}
        />
      )}
      <input
        type="number"
        id="current_page"
        value={currentPage}
        onChange={handlePageInputChange}
      />
      <div>from</div>
      <div>{lastPage}</div>
      {currentPage < lastPage && (
        <Button text="Next ->" type="empty" onClicked={handleNextPage} />
      )}
    </div>
  ) : (
    <></>
  );
}
